module.exports = __webpack_public_path__ + "static/img/main_sub_menu02.00e02a7d.svg";